import { DrawingLayer } from 'business/models/DrawingLayer';
import { RandomLayerDTO, RandomLayerGenerationListDTO } from 'business/models/Models';
import { isNullOrUndefined } from 'utils/Global';
import RandomLayerGroupIngredient from './RandomLayerGroupIngredient';

export default class RandomLayerGenerationList {
  public static CanPlatesBeGenerated(lyr: DrawingLayer) {
    // If a generation list doesn't contain any ingredients.
    const rlglRows: RandomLayerGenerationListDTO[] = [];
    (lyr.layerDetail as RandomLayerDTO).randomLayerIngredientGroup.map((rlig) => {
      rlig.randomLayerGenerationList.map((rlgl) => {
        rlglRows.push(rlgl);
      });
    });
    if (rlglRows.length == 0) {
      return false;
    }

    for (const rlglRow of rlglRows) {
      if (!isNullOrUndefined(rlglRow.randomLayerIngredientGroupId)) {
        const rlgi = RandomLayerGroupIngredient.GetRandomLayerGroupIngredientRows(lyr);
        if (rlgi.length > 0) {
          return true; //Some ingredients found so returning ture.
        }
      }
    }
    return false;
  }
}
